import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { cacheDom } from "../../utils/QuerySelectors.js"
import { setOpen, setCountry } from '../store/addressSlice'

const dom = {}
const qs = {
  list: 'data-addresses-list',
  add: 'data-address-add',
  countryOptions: 'data-country-options',
}
const qsAll = {
}

const AddressForm = () => {
  const dispatch = useDispatch()
  const { address, open } = useSelector((state) => state.address)
  cacheDom(dom, qs, qsAll)
  dom.list.classList.toggle('hidden', open)
  dom.add.classList.toggle('hidden', open)
  console.log(address)

  return (
    <form className={`flex flex-col w-full gap-3 bg-back ${open ? '' : 'hidden'}`} method='post' action={`/account/addresses${address && address.id ? '/' +  address.id : ''}`} acceptCharset='UTF-8'>
      <input type="hidden" name="form_type" value="customer_address" />
      <input type="hidden" name="utf8" value="✓" />
      <div className='grid grid-cols-1 lg:grid-cols-2 gap-3'>
        <div className="input-wrap border-accent-1">
          <label htmlFor="AddressFirstName">First Name *</label>
          <input
            type="text"
            id="AddressFirstName"
            name="address[first_name]"
            defaultValue={address && address.first_name}
            autoComplete="given-name"
            placeholder="First Name"
            required
          />
        </div>
        <div className="input-wrap border-accent-1">
          <label htmlFor="AddressLastName">Last Name *</label>
          <input
            type="text"
            id="AddressLastName"
            name="address[last_name]"
            defaultValue={address && address.last_name}
            autoComplete="family-name"
            placeholder="Last Name"
            required
          />
        </div>
      </div>
      <div className="input-wrap border-accent-1">
        <label htmlFor="Company">Company</label>
        <input
          type="text"
          id="Company"
          name="address[company]"
          defaultValue={address && address.company}
          autoComplete="given-name"
          placeholder="Company"
        />
      </div>
      <div className="input-wrap border-accent-1">
        <label htmlFor="AddressAddress1">Address 1 *</label>
        <input
          type="text"
          id="AddressAddress1"
          name="address[address1]"
          defaultValue={address && address.address1}
          autoComplete="address-line1"
          placeholder="Address 1 *"
          required
        />
      </div>
      <div className="input-wrap border-accent-1">
        <label htmlFor="AddressAddress2">Address 2</label>
        <input
          type="text"
          id="AddressAddress2"
          name="address[address2]"
          defaultValue={address && address.address2}
          autoComplete="address-line2"
          placeholder="Address 2"
        />
      </div>
      
      <div className={`grid gap-3 grid-cols-1 ${address && address.country && JSON.parse(dom.countryOptions.querySelector(`[value="${address.country}"]`).dataset.provinces).length > 0 ? 'lg:grid-cols-2' : ''}`}>
        <div className="input-wrap border-accent-1">
          <label htmlFor="AddressCity">City *</label>
          <input
            type="text"
            id="AddressCity"
            name="address[city]"
            defaultValue={address && address.city}
            autoComplete="address-level2"
            placeholder="City *"
            required
          />
        </div>
        {
          address && address.country && JSON.parse(dom.countryOptions.querySelector(`[value="${address.country}"]`).dataset.provinces).length > 0 &&
          <div className='select-wrap border-accent-1'>
            <label className='mb-3 block' htmlFor="AddressProvince">State *</label>
            <select
              id="AddressProvince"
              name="address[province]"
              defaultValue={address?.province}
              autoComplete="address-level1"
              required
            >
              {
                address && address.country && JSON.parse(dom.countryOptions.querySelector(`[value="${address.country}"]`).dataset.provinces).map((province, index) =>
                  <option value={province[1]} key={`province-${index}`}>{province[0]}</option>
                )
              }
            </select>
          </div>
        }
      </div>

      <div className='select-wrap border-accent-1'>
        <label htmlFor="AddressCountry">Country *</label>
        <select
          id="AddressCountry"
          name="address[country]"
          autoComplete="country"
          required
          value={address?.country}
          onChange={(e) => dispatch(setCountry(e.target.value))}
          dangerouslySetInnerHTML={{ __html: dom.countryOptions.innerHTML}}
        >
        </select>
      </div>

      <div className='grid grid-cols-1 lg:grid-cols-2 gap-3'>
        <div className="input-wrap border-accent-1">
          <label htmlFor="AddressZip">Postal Code *</label>
          <input
            type="text"
            id="AddressZip"
            name="address[zip]"
            defaultValue={address && address.zip}
            autoCapitalize="characters"
            autoComplete="postal-code"
            placeholder="Postal Code"
            required
          />
        </div>
        <div className="input-wrap border-accent-1">
          <label htmlFor="AddressPhone">Phone Number</label>
          <input
            type="tel"
            id="AddressPhone"
            name="address[phone]"
            defaultValue={address && address.phone}
            autoComplete="tel"
            placeholder="Phone Number"
          />
        </div>
      </div>
      <label
        htmlFor="address_default"
        className="checkbox-wrapper w-full"
      >
        <input type="checkbox" id="address_default" name="address[default]" value="1" defaultChecked={address && address.default == true} />
        <span className="checkbox-text justify-center !text-fore">Set as default address</span>
      </label>
      <div className='grid grid-cols-1 lg:grid-cols-4 gap-3 items-center'>
        <button className='button button--primary__filled w-full lg:col-span-3 !font-euclid !text-base !leading-4'>Save Address</button>
        <button type="reset" className='button button--primary w-full !font-euclid !text-base !leading-4' onClick={() => dispatch(setOpen(false))}>Cancel</button>
      </div>
      <div className='text-right text-xs leading-4 text-fore'>* Required Fields</div>
      { address && address.id ? <input type="hidden" name="_method" value="put" /> : null }
    </form>
  )
}

export default AddressForm